import { render } from "./IntergralRule.vue?vue&type=template&id=576cea8d&scoped=true"
import script from "./IntergralRule.vue?vue&type=script&lang=ts"
export * from "./IntergralRule.vue?vue&type=script&lang=ts"

import "./IntergralRule.vue?vue&type=style&index=0&id=576cea8d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-576cea8d"

export default script